import { render, staticRenderFns } from "./housingAdd.vue?vue&type=template&id=913b88d6"
import script from "./housingAdd.vue?vue&type=script&lang=js"
export * from "./housingAdd.vue?vue&type=script&lang=js"
import style0 from "./housingAdd.vue?vue&type=style&index=0&id=913b88d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports